import React from "react";
import { TextAreaProps } from "./types";
import TextArea from "./TextArea";

const TextAreaContainer: React.FC<TextAreaProps> = (props) => {
  return <TextArea {...props} />;
};

export default TextAreaContainer;
